#import "../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query PaymentEmailStatus($id: UUID!) {
  payment(id: $id) {
    id
    _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
